import React, { ComponentType } from 'react';
import {
	type IdentityVerificationHook,
	useIdentityVerification,
} from '../hooks';

export const withIdentityVerification = <P extends object>(
	Component: ComponentType<P & IdentityVerificationHook>
) => {
	return (props: P) => {
		const identityVerification = useIdentityVerification();
		return <Component {...props} {...identityVerification} />;
	};
};
